// extracted by mini-css-extract-plugin
module.exports = {"title":"_1zdB5u","body":"n_Gq4e","options":"_3o1pwb","displayFlexEnd":"_3g77y5"};